import {
  HIDE_CARRIER_BUS_MODAL,
  HIDE_CARRIER_DRIVER_MODAL,
  HIDE_CARRIER_MODAL,
  HIDE_NOTICE_TEMPLATE_MODAL,
  HIDE_SELECT_BUSES_AND_DRIVERS_MODAL,
  HIDE_SEND_NOTICE_MODAL,
  SHOW_CARRIER_BUS_MODAL,
  SHOW_CARRIER_DRIVER_MODAL,
  SHOW_CARRIER_MODAL,
  SHOW_NOTICE_TEMPLATE_MODAL,
  SHOW_SELECT_BUSES_AND_DRIVERS_MODAL,
  UPDATE_ROUTE_RELATIONS_SUCCESS,
  UPDATE_ROUTE_RELATIONS_FAILURE,
  SHOW_SEND_NOTICE_MODAL,
  NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS,
  NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE,
  SHOW_DEACTIVATE_ACCOUNT_MODAL,
  HIDE_DEACTIVATE_ACCOUNT_MODAL,
  SHOW_DELETE_ACCOUNT_MODAL,
  HIDE_DELETE_ACCOUNT_MODAL,
  SHOW_ADD_ACCOUNT_MODAL,
  HIDE_ADD_ACCOUNT_MODAL,
  SHOW_ADD_STUDENT_FORM,
  HIDE_ADD_STUDENT_FORM,
  SHOW_PARENT_STAFF_MODAL,
  HIDE_PARENT_STAFF_MODAL,
  SEARCH_USERS_FORM,
  SEARCH_USERS_FORM_SUCCESS,
  SEARCH_USERS_FORM_ERROR,
  HIDE_HISTORY_MAP_MODAL,
  SHOW_HISTORY_MAP_MODAL,
  ERROR_MODAL,
  HIDE_ERROR_MODAL,
} from 'constants/ActionTypes';

export const hideCarrierBusModal = () => ({
  type: HIDE_CARRIER_BUS_MODAL,
});

export const hideCarrierDriverModal = () => ({
  type: HIDE_CARRIER_DRIVER_MODAL,
});

export const hideCarrierModal = () => ({
  type: HIDE_CARRIER_MODAL,
});

export const hideNoticeTemplateModal = () => ({
  type: HIDE_NOTICE_TEMPLATE_MODAL,
});

export const hideSelectBusesAndDriversModal = () => ({
  type: HIDE_SELECT_BUSES_AND_DRIVERS_MODAL,
});

export const hideSendNoticeModal = () => ({
  type: HIDE_SEND_NOTICE_MODAL,
});

export const showCarrierBusModal = (carrierId = null, bus = {}) => ({
  type: SHOW_CARRIER_BUS_MODAL,
  payload: { carrierId, bus },
});

export const showCarrierDriverModal = (carrierId = null, driver = {}) => ({
  type: SHOW_CARRIER_DRIVER_MODAL,
  payload: { carrierId, driver },
});

export const showCarrierModal = (carrier = {}) => ({
  type: SHOW_CARRIER_MODAL,
  payload: { carrier },
});

export const showNoticeTemplateModal = (template = {}) => ({
  type: SHOW_NOTICE_TEMPLATE_MODAL,
  payload: { template },
});

export const showSelectBusesAndDriversModal = (routeId, busesAndDrivers) => ({
  type: SHOW_SELECT_BUSES_AND_DRIVERS_MODAL,
  payload: { routeId, busesAndDrivers },
});

// prefilledDiversion: optional { body, header, type, diversionNotificationId } — when set,
// SendNoticeDialog uses it as the `template` prop on <NotificationForm> AND wires
// diversionNotificationId into the form's state.diversionNotificationId slot.
// Used by task 09's RouteDetails banner-prefilled cancel composer flow.
export const showSendNoticeModal = (toRoute = false, routes = [], prefilledDiversion = null) => ({
  type: SHOW_SEND_NOTICE_MODAL,
  payload: { routes, toRoute, prefilledDiversion },
});

export const noticeTemplateModalSubmitedSuccess = () => ({
  type: NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS,
});

export const noticeTemplateModalSubmitedFailure = () => ({
  type: NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE,
});

export const updateRouteRelationsSuccess = () => ({
  type: UPDATE_ROUTE_RELATIONS_SUCCESS,
});

export const updateRouteRelationsFailure = () => ({
  type: UPDATE_ROUTE_RELATIONS_FAILURE,
});

export const showActivationAccountModal = payload => ({
  payload,
  type: SHOW_DEACTIVATE_ACCOUNT_MODAL,
});

export const hideActivationAccountModal = () => ({
  type: HIDE_DEACTIVATE_ACCOUNT_MODAL,
});

export const showDeleteAccountModal = payload => ({
  payload,
  type: SHOW_DELETE_ACCOUNT_MODAL,
});

export const hideDeleteAccountModal = () => ({
  type: HIDE_DELETE_ACCOUNT_MODAL,
});

export const showAddAccountModal = () => ({
  type: SHOW_ADD_ACCOUNT_MODAL,
});

export const hideAddAccountModal = () => ({
  type: HIDE_ADD_ACCOUNT_MODAL,
});

export const showAddStudentForm = payload => ({
  payload,
  type: SHOW_ADD_STUDENT_FORM,
});

export const hideAddStudentForm = () => ({
  type: HIDE_ADD_STUDENT_FORM,
});

export const showParentStaffModal = ({ userId = '', editOnList = false }) => ({
  type: SHOW_PARENT_STAFF_MODAL,
  payload: { userId, editOnList },
});

export const hideParentStaffModal = () => ({
  type: HIDE_PARENT_STAFF_MODAL,
});

export const searchUsersForm = (query = {}, affectQuery = false) => ({
  type: SEARCH_USERS_FORM,
  payload: { affectQuery, query },
});

export const searchUsersFormSuccess = (users, pageCount) => ({
  type: SEARCH_USERS_FORM_SUCCESS,
  payload: { users, pageCount },
});

export const searchUsersFormError = () => ({
  type: SEARCH_USERS_FORM_ERROR,
});

export const showHistoryMapModal = mapData => ({
  type: SHOW_HISTORY_MAP_MODAL,
  payload: mapData,
});

export const hideHistoryMapModal = () => ({
  type: HIDE_HISTORY_MAP_MODAL,
});

export const showErrorModal = (errorMessage = '') => ({
  type: ERROR_MODAL,
  payload: { errorMessage },
});

export const hideErrorModal = () => ({
  type: HIDE_ERROR_MODAL,
});
